import { Box } from "@mui/system";
import ConfigRoteiros from "./configRoteiros";
import ConfigSuporte from "./configSuporte";

import ConfigOpenTicketCliente from "./configOpenTicketCliente";
import ConfigTickets from "./configTickets";
import Formularios from "../../../6.0-suporte/formularios";
import ConfigRfo from "./configRfo";
import ConfigOpenTicket from "./configOpenTicket";
import ConfigFluxoAtendimento from "./configFluxoAtendimento";
import ConfigMotivoFechamento from "./configMotivoFechamento";
import { temErp } from "../../../../../services/erpSistema";
import BuscaConfiguracao from "../buscaConfiguracao";

// Índice da busca (ver ../buscaConfiguracao). Ao criar uma configuração nova
// na tela, inclua-a aqui com o mesmo id.
const soHubsoft = () => temErp("HUBSOFT");

const CAMPOS_ABERTURA = (prefixo) => [
  [`${prefixo}tipo`, "Tipo de atendimento", "abertura ticket"],
  [`${prefixo}status`, "Status do atendimento", "abertura ticket"],
  [`${prefixo}origem`, "Origem do contato", "abertura ticket canal"],
  [`${prefixo}responsavel`, "Usuário responsável", "abertura ticket atendente"],
  [`${prefixo}etapa`, "Etapa do fluxo de atendimento", "abertura ticket"],
  [
    `${prefixo}campos`,
    "Campos personalizados do formulário",
    "campo livre telefone formulario",
  ],
];

const SECOES = [
  {
    secao: "cliente",
    titulo: "Configurações de cliente",
    visivel: soHubsoft,
    termos: "portal permissoes cliente",
    itens: [
      [
        "cliente-abrir",
        "Liberar abertura de ticket para todos os clientes",
        "portal permitir abrir",
      ],
      [
        "cliente-mensagem",
        "Liberar envio de mensagem no ticket",
        "portal permitir enviar mensagem",
      ],
      [
        "cliente-anexo",
        "Liberar anexo de arquivos no ticket",
        "portal permitir anexar arquivo",
      ],
      [
        "cliente-permissoes",
        "Permissões por cliente",
        "buscar cliente abrir ticket mensagem anexo",
      ],
      [
        "cliente-linha-tempo",
        "Exibir linha do tempo para o cliente",
        "timeline",
      ],
      [
        "cliente-duplicado",
        "Alerta de ticket duplicado por unidade",
        "duplicidade janela tempo",
      ],
    ],
  },
  {
    secao: "abertura-cliente",
    titulo: "Configurações de abertura de ticket por clientes",
    visivel: soHubsoft,
    termos: "portal novo ticket",
    itens: CAMPOS_ABERTURA("ac-"),
  },
  {
    secao: "abertura-permissao",
    titulo: "Configurações de abertura de ticket por permissão",
    visivel: soHubsoft,
    termos: "novo ticket interno",
    itens: [
      ["ap-permissao", "Permissão a ser configurada", "perfil usuario"],
      ...CAMPOS_ABERTURA("ap-"),
    ],
  },
  {
    secao: "rfo",
    titulo: "Configurações de RFO",
    visivel: soHubsoft,
    termos: "relatorio de falha",
    itens: [
      [
        "rfo-todos",
        "RFO obrigatório no encerramento de todos os tickets",
        "fechamento",
      ],
      [
        "rfo-motivo",
        "RFO obrigatório por motivo de encerramento",
        "fechamento",
      ],
    ],
  },
  {
    secao: "fluxo",
    titulo: "Configurações do fluxo de atendimento",
    visivel: soHubsoft,
    termos: "etapas",
    itens: [["fluxo-select", "Fluxo de atendimento da HubSoft", "etapas"]],
  },
  {
    secao: "motivo",
    titulo: "Configurações de motivo de fechamento",
    visivel: soHubsoft,
    termos: "encerramento",
    itens: [
      [
        "motivo-filtro",
        "Filtro SQL dos motivos de fechamento",
        "testar previa",
      ],
    ],
  },
  {
    secao: "filtro-tipo",
    titulo: "Filtro de atendimentos por tipo",
    termos: "tipo de atendimento tickets visiveis",
    itens: [
      ["filtro-interno", "Tipos de atendimento visíveis no interno", "filtro"],
      [
        "filtro-cliente",
        "Tipos de atendimento visíveis para o cliente",
        "filtro portal",
      ],
    ],
  },
  {
    secao: "roteiros",
    titulo: "Roteiros de atendimento",
    termos: "script mensagem pronta",
    itens: [],
  },
  {
    secao: "formularios",
    titulo: "Formulários de avaliação",
    termos: "pesquisa satisfacao",
    itens: [],
  },
  {
    secao: "sugestoes",
    titulo: "Sugestões de melhorias",
    termos: "formulario",
    itens: [],
  },
];

export default function Suporte() {
  // Cada seção aparece se o sistema tem um ERP que a usa; nas por ERP, o ERP é
  // escolhido dentro dela. Tickets vale para HubSoft e IXC; roteiros e
  // formulários (avaliação/sugestão) não dependem de ERP.
  return (
    <Box sx={{ p: 2 }}>
      <BuscaConfiguracao
        secoes={SECOES}
        placeholder="Buscar configuração (ex.: anexo, RFO, duplicado)"
      />
      {temErp("HUBSOFT") && (
        <>
          <ConfigSuporte />
          <ConfigOpenTicketCliente />
          <ConfigOpenTicket />
          <ConfigRfo />
          <ConfigFluxoAtendimento />
          <ConfigMotivoFechamento />
        </>
      )}
      <ConfigTickets />
      <ConfigRoteiros />
      <Formularios />
    </Box>
  );
}
